import { useQuery } from '@tanstack/react-query';
import fetchApi from './fetchApi';

const useOfficesQuery = () =>
  useQuery({ queryKey: ['offices'], queryFn: () => fetchApi<Odoo.Office[]>('/api/offices') });

export default useOfficesQuery;
